.alert.cookie-message {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: $zindex-fixed;
	background-color: $white;
	padding: 2rem 3rem;
	width: 100%;

	.container {
		padding: 0;
		gap: 2rem;
		justify-content: space-between;
		.text-wrap {
			max-width: 60%;
			h2 {
				color: $font-gray;
				font-size: 1.25rem;
				text-align: left;
				letter-spacing: 0.05rem;
				font-family: $font-family-secondary;
				font-weight: 700;
				@include line-height(30);
			}
			p {
				font-weight: 400;
			}
			a {
				color: $font-gray;
				text-decoration: none;
				&:hover,
				&:focus {
					text-decoration: underline;
				}
			}
		}
	}
}

.kdx-cookie {
	background-color: #FFF;
	box-shadow: 0px -4px 14px rgba(0, 37, 64, 0.10);

	> .container {
		padding: 0;
		display: flex;
	}

	p {
		margin: 0 0 0.5rem 0;
		padding: 0;
		color: $font-gray;
	}

	.alert-links {
		@include row-cols(1);
		display: flex;
		flex-direction: row;
		gap: 2rem;

		> * {
			flex: unset !important;
			width: unset !important;
		}

		[class^="arrow-link"] {
			padding: 0;
			width: auto;

			.svg-icon {
				border-bottom: solid 1px $primary;
				margin: 0 0 0 5px;
				bottom: -1px;

				svg {
					margin: 0 0 1px;
				}
			}
		}

		.btn {
			max-width: 360px;
			margin: auto;
			.svg-icon {
				margin-left: 0.25rem;
			}
		}

	}
}

@include media-breakpoint-down(md) {
	.alert.cookie-message {
		.container {
			flex-direction: column;
			gap: 0.5rem;

			> * {
				padding: 0;
			}

			.text-wrap {
				max-width: unset;
				a {
					text-decoration: underline;
				}
			}

			img {
				display: none;
			}
		}
	}

	.kdx-cookie {
		> .container {
			padding: 0 35px;
		}

		.alert-links {
			padding: 0;
			margin: 15px 0 0;
			gap: 0;

			.btn {
				width: 100% !important;
				.svg-icon {
					display: inline-block;
					visibility: visible;
				}
				&.btn-underline {
					padding: 0.85rem 3.5rem 0.75rem;
					text-decoration: none;
				}
			}

			> :first-child { 
				margin-bottom: 0;
			}
		}
	}
}

@include media-breakpoint-down(xl) {
	.kdx-cookie {
		.alert-links {
			flex-direction: column-reverse;
			gap: 1rem;
			.btn-underline {
				order: 2;
			}
		}
	}
}